function isNumeric(value) {
  return Number.isFinite(+value);
}

function getValueFromRow(row, index) {
  return row.rowValues[index].sortValue ?? row.rowValues[index].value;
}

function compareAscending(rowOneValue, rowTwoValue) {
  return isNumeric(rowOneValue) && isNumeric(rowTwoValue)
    ? rowOneValue - rowTwoValue
    : rowOneValue.localeCompare(rowTwoValue);
}

function compareDescending(rowOneValue, rowTwoValue) {
  return isNumeric(rowOneValue) && isNumeric(rowTwoValue)
    ? rowTwoValue - rowOneValue
    : rowTwoValue.localeCompare(rowOneValue);
}

function indexIsValid(row, index) {
  return (index != null) && (index < row.rowValues.length);
}

function compareRowValues(rowOne, rowTwo, index, direction) {
  if (!indexIsValid(rowOne, index)) {
    return 0;
  }

  const rowOneValue = getValueFromRow(rowOne, index);
  const rowTwoValue = getValueFromRow(rowTwo, index);

  switch (direction) {
    case -1:
      return compareDescending(rowOneValue, rowTwoValue);
    case 1:
      return compareAscending(rowOneValue, rowTwoValue);
    default:
      return 0;
  }
}

export default function sortRows(
  /** @type {TableRow} */
  rowOne,

  /** @type {TableRow} */
  rowTwo,

  /** @type {number} */
  defaultSortIndex,

  /** @type {number} */
  defaultSortDirection,

  /** @type {number} null = none */
  sortedIndex,

  /** @type {number} -1=desc, 0=none, 1=asc */
  sortDirection,
) {
  const primaryComparison = compareRowValues(rowOne, rowTwo, sortedIndex, sortDirection);
  if (primaryComparison !== 0) {
    return primaryComparison;
  }

  if (defaultSortIndex == null) {
    return 0;
  }

  return compareRowValues(rowOne, rowTwo, defaultSortIndex, defaultSortDirection);
}